import React, { useEffect } from "react";
import { useState } from "react";
import UserManagement from "../../Layouts/Menu/UserManagement/UserManagement";
import CreateUserPopup from "../../Components/Popups/CreateUserPopup/CreateUserPopup";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUsers,
  createUser,
  updateUser,
  deleteUser,
} from "../../redux/User/UserSlice";
import ComponentLoader from "../../Components/loaders/ComponentLoader/ComponentLoader";
import DropActions from "../../Components/DropActions/DropActions.jsx";
import Image from "../../Components/Image/Image";

import Button from "../../Components/Button/Button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Capitalize from "../../Components/Capitalize/Capitalize";
import { clearAllSliceStates } from "../../redux/authentication/authSlice";
import {
  clearUserSliceStates,
  clearUserSliceData,
} from "../../redux/User/UserSlice";
import EditUserPopup from "../../Components/Popups/EditUserpopup/EditUserPopup.jsx";
import LogoutPopup from "../../Components/Popups/LogoutPopup/LogoutPopup.jsx";

import Redtrash from "../../assets/svg/Redtrash.svg";
import Edit from "../../assets/svg/edit.png";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown.jsx";
import "../AllBlogs/AllBlogs.css";
import "../AllBlogs/TableStyle.css";
const Createuser = () => {
  const dispatch = useDispatch();
  const {
    isuserSliceFetching,
    isuserSliceFetchingSmall,
    isuserDeleteSliceSuccess,

    isuserSliceSuccess,
    isuserSliceError,
    isuserEditSliceSuccess,
    userSliceErrorMessage,
    userSliceSuccessMessage,
    allOrgUsers,
    userCount,
  } = useSelector((state) => state.user);
  const {
    isAuthSliceFetching,
    isAuthSliceSuccess,
    isAuthSliceError,
    authSliceErrorMessage,
    authSliceSuccessMessage,
    isAuthSliceFetchingSmall,
  } = useSelector((state) => state.authentication);
  const [isCreatePopup, setIsCreatePopup] = useState(false);
  const [isRolePopup, setIsRolePopup] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isEditPopup, setIsEditPopup] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState([]);
  const [selecteduser, setSelecteduser] = useState([]);

  const [isDropAction, setIsDropAction] = useState(false);
  // UserId that will be used to DELETE User
  const [roleIds, setRoleIds] = useState(null);
  const [programIds, setProgramIds] = useState(null);

  // For pagination
  const [perPageDropName, setPerPageDropName] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // For Search
  const [searchQuery, setSearchQuery] = useState("");

  const createUserFormObject = {
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    password: "",
    alternateEmail: "",
    role: "",
  };

  const createRoleFormObject = {
    name: "",
    description: "",
    modules: [],
  };

  const [createUserFormData, setCreateUserFormData] =
    useState(createUserFormObject);
  const [createRoleFormData, setCreateRoleFormData] =
    useState(createRoleFormObject);

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    password: "",
    alternateEmail: "",
    role: "",
  });
  const handleDelete = (userId) => {
    console.log("del", userId);
    let obj = {
      id: selectedUserId,
    };
    dispatch(deleteUser(obj));
  };
  useEffect(() => {
    getAllusersData();

    return () => {
      dispatch(clearUserSliceStates());
      dispatch(clearUserSliceData());
    };
  }, [searchQuery, perPageDropName]);

  useEffect(() => {
    if (isuserDeleteSliceSuccess) {
      successToast();
      setIsDeletePopup(false);
    }
    return () => {
      dispatch(clearUserSliceStates());
    };
  }, [isuserDeleteSliceSuccess]);

  useEffect(() => {
    if (isAuthSliceSuccess) {
      dispatch(clearAllSliceStates());
    }
  }, [isAuthSliceSuccess]);

  useEffect(() => {
    if (isAuthSliceError) {
      chngPassErrorToast();
    }
  }, [isAuthSliceError]);

  useEffect(() => {
    if (isuserEditSliceSuccess) {
      successToast();
      // setDeletePopup(false);
      setIsEditPopup(false);
    }
    return () => {
      dispatch(clearUserSliceStates());
    };
  }, [isuserEditSliceSuccess]);






  const handleEditPopup = (obj) => {
    console.log("edit", obj);

    dispatch(updateUser(obj));
  };

  const getAllusersData = () => {
    dispatch(
      getAllUsers({
        page: 1,

        count:perPageDropName ,
        searchValue: searchQuery,
      })
    );

    setCurrentPage(1);
  };
  console.log(JSON.stringify(allOrgUsers.length) + "all org data");
  console.log(userCount + "count");

  //  To load more data ( Pagination )
  const loadMore = () => {
    dispatch(
      getAllUsers({
        count: perPageDropName,
        page: currentPage + 1,
        searchValue: searchQuery,
      })
    );
    setCurrentPage(currentPage + 1);
    // setIsAllChecked(false);
  };
  //  Change the page size
  const showPerPage = (perPageCount) => {
    setPerPageDropName(perPageCount);
    setCurrentPage(1);
  };

  // Handeling the search functionality
  const userListSearchFunction = (searchValue) => {
    // searchValue = searchValue?.trim();

    const keywords = searchValue.split(",").map((keyword) => keyword.trim());
    console.log(searchQuery);
    setCurrentPage(1);
    setSearchQuery(keywords[0]);
  };
  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
    // setSelectedApplicants([]);
    // setIsAllChecked(false);
  };
  const toggleCreateUserPopup = () => {
    setIsCreatePopup(!isCreatePopup);
  };

  const toggleCreateRolePopup = () => {
    setIsRolePopup(!isRolePopup);
  };

  const toggleActionDropdown = (rowId, userName) => {
    setIsDropAction(isDropAction === rowId ? false : rowId);
    setSelectedUserId(rowId);
    setSelecteduser(userName);
  };

  /**Handling createUserFormData with single onChange */
  const onChangeFormData = (event) => {
    const { name, value } = event.target;
    setCreateUserFormData({
      ...createUserFormData,
      [name]: value?.trim(),
    });
    setErrors({
      firstName: "",
      lastName: "",
      mobileNumber: "",
      email: "",
      password: "",
    });
  };

  console.log("printing role Ids", roleIds);

  // Function to create new user

  const createNewUser = () => {
    // First checking if createUserFormData is valid
    let newErrors = {
      firstName: "",
      lastName: "",
      mobileNumber: "",
      email: "",
      password: "",
    };
    function validatePassword(password) {
      // Check if the password is at least 8 characters long
      if (password.length < 8) {
        newErrors.password = "Password should be at least 8 character";
        return false;
      }

      // Check if the password contains at least one lowercase letter
      var lowercaseRegex = /[a-z]/;
      if (!lowercaseRegex.test(password)) {
        console.log("first", password);
        newErrors.password = "Password should contain a lowercase character";
        return false;
      }

      // Check if the password contains at least one uppercase letter
      var uppercaseRegex = /[A-Z]/;
      if (!uppercaseRegex.test(password)) {
        newErrors.password = "Password should contain a uppercase character";
        return false;
      }

      // Check if the password contains at least one number
      var numberRegex = /[0-9]/;
      if (!numberRegex.test(password)) {
        newErrors.password = "Password should contain at least one number";
        return false;
      }

      // Check if the password contains at least one special character
      var specialCharRegex = /[!@#$%^&*()\-=_+[\]{}|;':"\\|,.<>/?]/;
      if (!specialCharRegex.test(password)) {
        newErrors.password =
          "Password should contain at least one special character";
        return false;
      }

      // Check if the password contains any spaces
      if (password.indexOf(" ") !== -1) {
        newErrors.password = "Password should not contain spaces";
        return false;
      }

      return true;
    }

    if (!createUserFormData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+/.test(createUserFormData.email)) {
      newErrors.email = "Invalid email address.";
    }

    if (!createUserFormData.password) {
      newErrors.password = "Password is required.";
    } else if (validatePassword(createUserFormData.password))
      if (!createUserFormData.firstName) {
        newErrors.firstName = "First name is required.";
      }

    if (!createUserFormData.mobileNumber) {
      newErrors.mobileNumber = "Phone Number is required.";
    } else if (!/^[1-9]\d{9}$/.test(createUserFormData.mobileNumber)) {
      newErrors.mobileNumber = "Invalid mobile number.";
    }

    if (!createUserFormData.email) {
      newErrors.email = "Email is required.";
    }
    // if (!createUserFormData.password) {
    //   newErrors.password = "Password is required.";
    // } else if (createUserFormData.password.length < 6) {
    //   newErrors.password = "Minimum 6 characters requied";
    // }

    if (
      newErrors.email ||
      newErrors.password ||
      newErrors.firstName ||
      newErrors.mobileNumber
    ) {
      setErrors(newErrors);
      return;
    }
    // TODO : have to update it , it seems temporary solution ( below 2 lines )
    const userObj = createUserFormData;
    // const roleid = roleIds.map((ele)=>{

    //   return  ele.value;
    // })
    userObj.role = roleIds?.value;
    console.log(roleIds?.value + ".....roleids");
    dispatch(createUser(userObj));
  };

  useEffect(() => {
    if (isuserSliceSuccess) {
      setCreateUserFormData({
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: "",
        password: "",
        alternateEmail: "",
        role: "",
      });
      // Closing the Create User Popup
      setIsCreatePopup(false);

      // Closing the Create Role Popup
      setIsRolePopup(false);

      // Closing the Delete User Popup
      setIsDeletePopup(false);

      // Closing the Edit User Role Popup
      setIsEditPopup(false);

      // dispatching an action to reset the Management Slice States
      dispatch(clearUserSliceStates());

      successToast();
    }
  }, [isuserSliceSuccess]);

  useEffect(() => {
    if (isuserSliceError) {
      // dispatching an action to reset the Management Slice States
      dispatch(clearUserSliceStates());

      errorToast();
    }
  }, [isuserSliceError]);

  const onChangePerPage = (obj) =>{
    setPerPageDropName(obj.id)
  }

  const UserManagementMenuRightOptions = [
    () => (
      <CustomDropdown
      className={"current"}
      dropName={perPageDropName}
      options={[
        { name: "10", id: 10 },
        { name: "20", id: 20 },
        { name: "30", id: 30 },
        { name: "40", id: 40 },
        { name: "50", id: 50 },
        { name: "Max", id: userCount },
      ]}
      isActive={perPageDropName}
      setIsActive={setPerPageDropName}
      onSelect={onChangePerPage} />
    ),
    () => (
      <Button
        onClick={() => setIsCreatePopup(true)}
        className={"BlueFillButton iconButton"}
        name={"Create User"}
        src={"https://cdn.mastersunion.org/assets/dinero/add.svg"}
      />
    ),
  ];
  const dropActionOptions = [
    {
      label: "Delete User",
      onClick: () => setIsDeletePopup(true),
      icon: Redtrash,
    },
    { label: "Edit User", onClick: () => setIsEditPopup(true), icon: Edit },
   
  ];

  const successToast = () => {
    toast.success(userSliceSuccessMessage, {
      //   position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };


  const errorToast = () => {
    toast.error(userSliceErrorMessage, {
      //   position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };
  const chngPassErrorToast = () => {
    toast.error(authSliceErrorMessage, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  return (
    <>
      <ToastContainer />
      <UserManagement
        searchbar={true}
        searchFunction={userListSearchFunction}
        clearSearch={clearSearch}
        currentCount={allOrgUsers?.length}
        totalCount={userCount}
        UserManagementMenuRightOptions={UserManagementMenuRightOptions}
      />
      {isDeletePopup && (
        <LogoutPopup
          showActive={isDeletePopup}
          userId={selectedUserId}
          message={"Are you sure you want to delete this user?"}
          onCancel={() => setIsDeletePopup(false)}
          onAllow={handleDelete}
          isPopupFetching={isuserSliceFetchingSmall}
        />
      )}
     
      <div className="wrapperBox doubleMenu">
        {isuserSliceFetching && allOrgUsers?.length == 0 && <ComponentLoader />}

        {isCreatePopup && (
          <CreateUserPopup
            width={900}
            isActive={isCreatePopup}
            onClickCreateUser={createNewUser}
            onClickClosePopup={() => setIsCreatePopup(false)}
            onChangeFormData={onChangeFormData}
            errors={errors}
            isCreateUserPopupFetching={isuserSliceFetching}
            dropdownOptions={["user", "admin"]}
            setRoleIds={setRoleIds}
            setProgramIds={setProgramIds}
          />
        )}
        {isEditPopup && (
          <EditUserPopup
            isActive={isEditPopup}
            onClickClosePopup={() => setIsEditPopup(false)}
            errors={errors}
            isCreateUserPopupFetching={isuserSliceFetching}
            setRoleIds={setRoleIds}
            dropdownOptions={["user", "admin"]}
            userDetails={selecteduser}
            onSubmit={handleEditPopup}
            userId={selectedUserId}
          />
        )}

        <div className="tableWrapper  wrapWithButton checkboxTable noIconTable actionFix">
          <table className="darkHeaderTable">
            <thead>
              <tr>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/teacher.svg" alt="" />
                    Name
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Email ID
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Mobile Number
                  </div>
                </th>

                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Role
                  </div>
                </th>

                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {allOrgUsers?.length > 0 &&
                allOrgUsers.map((orgUser) => (
                  <tr key={orgUser._id}>
                    <td>
                      <div className="tableData textBlue">
                        <Capitalize
                          str={`${orgUser.firstName} ${orgUser.lastName}`}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="tableData">{orgUser.email}</div>
                    </td>
                    <td>
                      <div className="tableData">{orgUser.mobileNumber}</div>
                    </td>

                    <td>
                      <div className="tableData toptipHover pointer">
                        {orgUser.role}
                      </div>
                    </td>

                    <td>
                      <div
                        className="tableData"
                        onClick={() =>
                          toggleActionDropdown(orgUser._id, orgUser)
                        }
                      >
                        <Image name={"setting"} classname={"settingIcon"} />
                        <DropActions
                          isActive={isDropAction === orgUser._id}
                          dropActionOptions={dropActionOptions}
                          // onDelteAction={() => setIsDeletePopup(true)}
                          onEditAction={() => setIsEditPopup(true)}
                          userId={orgUser._id}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              {allOrgUsers?.length === 0 && !isuserSliceFetching && (
                <tr>
                  <td colSpan={"11"}>
                    <span className="noData">
                      <img
                        src={
                          "https://cdn.mastersunion.org/assets/imgV2/noDataDineroNew2.png"
                        }
                        alt=""
                      />
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {allOrgUsers?.length !== userCount && (
          <div className="loadMoreWrapper">
            <Button
              isWaiting={allOrgUsers?.length > 0 && isuserSliceFetchingSmall}
              onClick={loadMore}
              className={"BlueFillButton"}
              name={"Load More"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Createuser;
